import { type SearchUserAppRoleViewQuery } from '@user-management/graphql';

import { type UserStatus } from '../../constants';

import { type RoleUserAdditionListItem } from './columns';

export function mapRoleUserAdditionListItem(
  users: SearchUserAppRoleViewQuery['getUserAppRoleView']['users'],
) {
  const mappedArray = users.map((user) => {
    const mappedObject: RoleUserAdditionListItem = {
      id: user.id,
      firstName: user.firstname,
      lastName: user.lastname,
      status: (user.status ?? '-') as UserStatus,
      email: user.email ?? '-',
      profilePic: '',
      invitationExpireAt: user.invitationExpireAt,
    };
    return mappedObject;
  });
  return mappedArray;
}
